export enum DiffBadgeNature {
    New = "New",
    Added = "Added",
    Removed = "Removed"
}